import { initializeApp } from 'firebase/app';
import { getAuth, onAuthStateChanged, signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getMessaging } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyDsIfu5zwb6Q9qC3JIdq5otKsECcsImBxs",
  authDomain: "shareholders.hotelonline.co",
  projectId: "ho-shareholders",
  storageBucket: "ho-shareholders.firebasestorage.app",
  messagingSenderId: "379209256417",
  appId: "1:379209256417:web:8220d05ed4c4d3032496a0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
const auth = getAuth(app);
const db = initializeFirestore(app, {
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
  experimentalForceLongPolling: false, // Use WebSocket by default, fallback to long polling
});
const storage = getStorage(app);
const messaging = getMessaging(app);

export { auth, db, storage, messaging, onAuthStateChanged, signInWithEmailAndPassword, signOut }; 